exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".biomeList{display:flex;justify-content:center;flex-wrap:wrap}.biomeList .biome{margin:8px;width:64px;height:64px}.biomeList .biome.selected .biomeImage{border:1px solid #fff}.biomeList .biomeImage{border-radius:5px;border:1px solid transparent}.biomeList .biomeImage:hover{border:1px solid #fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2711443b","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/BiomeList.vue
// module id = 98
// module chunks = 0